<template>
  <div class="community-manage app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>社区名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入社区名称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>所在地</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入所在地" v-model="table.search.area"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>社区状态</p>
          </a-col>
          <a-col>
            <a-select class="app-block" v-model="table.search.status" placeholder="请选择社区状态">
              <a-select-option :value="1">启用</a-select-option>
              <a-select-option :value="0">禁用</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newCommunity()">新增社区</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id"
      :pagination="table.page" @change="handlePageChange">
      <template slot="state" slot-scope="text, data">
        <a-switch :checked="data.state === 1" :loading="data.stateLoading" @click="stateChange(data)"></a-switch>
      </template>

      <template slot="dnk_face_switch" slot-scope="text, data">
        <a-switch :checked="data.dnk_face_switch === 1" :loading="data.stateLoading" @click="faceChange(data)"></a-switch>
      </template>

      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="editCommunity(data)">编辑</a-button>
          <a-button type="link" @click="deleteCommunity(data)">删除</a-button>
        </a-space>
      </template>
    </a-table>
  </div>
</template>

<script>
import CommunityService from '@/io/community.js';

export default {
  name: 'CommunityManage',
  data() {
    let self = this;
    return {
      table: {
        loading: false,
        search: {
          name: null,
          area: null,
          status: []
        },
        page: {
          total: 0,
          current: 1,
          pageSize: 10,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal() {
            return `共${self.table.page.total}条`;
          }
        },
        data: [],
        columns: [
          {
            title: '社区名称',
            dataIndex: 'name'
          },
          {
            title: '所在区域',
            dataIndex: 'region'
          },
          {
            title: '楼栋数',
            dataIndex: 'building_count'
          },
          {
            title: '住户数',
            dataIndex: 'owner_count'
          },
          // {
          //   title: '可视对讲',
          //   dataIndex: 'intercom'
          // },
          // {
          //   title: '道闸',
          //   dataIndex: 'gate'
          // },
          {
            title: '社区状态',
            scopedSlots: { customRender: 'state' }
          },
          {
            title: '人脸开关',
            scopedSlots: { customRender: 'dnk_face_switch' }
          },
          {
            title: '操作',
            scopedSlots: { customRender: 'action' },
          }
        ]
      }
    }
  },
  activated() {
    this.initData();
  },
  methods: {
    stateChange(data) {
      let checked = data.state === 1;
      data.stateLoading = true;
      CommunityService[checked ? 'disable' : 'enable'](data.id).then(res => { }).catch(err => { }).finally(() => {
        this.$afterFormSubmit(checked ? '关闭成功' : '开启成功');
        data.state = checked ? 0 : 1;
        data.stateLoading = false;
      });
    },
    faceChange(data) {
      let checked = data.dnk_face_switch === 1 ? 0 : 1;
      data.stateLoading = true;
      CommunityService.faceChange(data.id, checked).then(res => { }).catch(err => { }).finally(() => {
        this.$afterFormSubmit(checked ? '开启成功' : '关闭成功');
        data.dnk_face_switch = checked === 0 ? 0 : 1;
        data.stateLoading = false;
      });
    },

    editCommunity(data) {
      this.$router.push(`/platform/community_manage/edit/${data.id}`);
    },
    deleteCommunity(data) {
      let self = this;
      this.$confirm({
        title: '提示',
        content: '确认删除此社区？',
        onOk() {
          CommunityService.del(data.id).then(res => {
            self.initData();
          }).catch(err => { });
        }
      });
    },
    newCommunity() {
      this.table.page.current = 1;
      this.$router.push('/platform/community_manage/new');
    },
    searchTable() {
      this.table.page.current = 1;
      this.initData();
    },
    resetSearchTable() {
      this.table.search = {
        name: null,
        area: null,
        status: []
      };
      this.searchTable();
    },
    handlePageChange(page) {
      this.table.page.current = page.current;
      this.table.page.pageSize = page.pageSize;
      this.initData();
    },
    initData() {
      this.table.loading = true;
      return CommunityService.listPage(
        this.table.search.name,
        this.table.search.area,
        this.table.search.status,
        this.table.page.current,
        this.table.page.pageSize
      ).then(res => {
        this.table.data = res.data.map(val => {
          val.region = `${val.province} / ${val.city} / ${val.area}`;
          val.stateLoading = false;
          val.intercom = val.mj_switch ? '开' : '关';
          val.gate = val.gate_switch ? '开' : '关';
          return val;
        });
        this.table.page.total = res.meta.pagination.total;
      }).catch(err => { }).finally(() => {
        this.table.loading = false;
      });
    },
  },
}
</script>

<style lang="less" scoped></style>